import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'sf-font';
import Home from './pages/Home';
import About from './pages/About';
import TokenInfo from './pages/TokenInfo';
import Roadmap from './pages/Roadmap';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
    };
  }

  render() {
   

    return (
      <Router>
        <Routes>  
         <Route path="/" element={<Home />} />
        
          <Route path="/about" element={<About />} />

          <Route path="/tokenInfo" element={<TokenInfo />} />

          <Route path="/roadmap" element={<Roadmap />} />

        </Routes>
      </Router>
    );
  }
}

export default App;
